<script>
export default {};
</script>

<template>
  <!-- START BLOG -->
  <section class="section bg-light pt-5" id="blog">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Nosotros</h1>
          <div class="section-title-border margin-t-20"></div>
          <p class="section-subtitle text-muted text-center font-secondary padding-t-30">Voy Seguro USA es un proyecto de
            IBS Consultores "Tu mejor agente de seguros y fianzas" cuyo principal objetivo es ofrecer cobertura de
            Responsabilidad Civil para autos mexicanos en
            Estados Unidos y Canadá, asesorando adecuadamente a nuestros clientes con el fin de cubrir sus necesidades de
            seguridad y estabilidad económica ante cualquier contingencia.

          </p>
        </div>
      </div>

      <div class="row margin-t-30">
        <div class="col-lg-4">
          <div class="blog-box margin-t-30 hover-effect">
            <img src="@/assets/images/blog/img-1.jpg" class="img-fluid" alt />
          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog-box margin-t-30 hover-effect">
            <img src="@/assets/images/blog/img-2.jpg" class="img-fluid" alt />
          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog-box margin-t-30 hover-effect">
            <img src="@/assets/images/blog/img-3.jpg" class="img-fluid" alt />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END BLOG -->
</template>